import { Component, OnInit } from '@angular/core';
import { AllapiService } from 'src/app/allapi.service';

@Component({
  selector: 'app-vancouver-knights',
  templateUrl: './vancouver-knights.component.html',
  styleUrls: ['./vancouver-knights.component.css']
})
export class VancouverKnightsComponent implements OnInit {

  yearname: any = 2019;
  teamPlayers: any = [];
  allResult: any = [];
  teamPlayersStats: any = [];
  teamNameData: any = [];
  yearnameforimage: any = '2024';
  matchroW: any;
  urlRefresh: any;
  deviceStatus: string;
  getInnerHeight(): void {
    this.deviceStatus = this.server.checkSystemWidth();
    console.log('this.deviceStatus :>> ', this.deviceStatus);
  }
  constructor(private server: AllapiService) {

  }

  getSquadJson() {
    if (this.yearnameforimage == '2024') {
      this.teamPlayers = [
    {
        'profileimg': 'Usman Khawaja.png',
        'PlayerName': 'Usman Khawaja',
        'Specialization': 'Batter',
    },
    {
        'profileimg': 'Mohammad Amir.png',
        'PlayerName': 'Mohd. Amir',
        'Specialization': 'Bowler',
    },
    {
        'profileimg': 'Reeza Hendricks.png',
        'PlayerName': 'Reeza Hendricks',
        'Specialization': 'Batter',
    },
    {
        'profileimg': 'Asif Ali.png',
        'PlayerName': 'Asif Ali',
        'Specialization': 'Batter',
    },
    {
        'profileimg': 'Michael Rippon.png',
        'PlayerName': 'Michael Rippon',
        'Specialization': 'All Rounder',
    },
    {
        'profileimg': 'Dwaine Pretorius.png',
        'PlayerName': 'Dwaine Pretorius',
        'Specialization': 'All Rounder',
    },
    {
        'profileimg': 'Sandeep Lamichhane.png',
        'PlayerName': 'Sandeep Lamichhane',
        'Specialization': 'Bowler',
    },
    {
        'profileimg': 'Dipendra Singh Airee.png',
        'PlayerName': 'Dipendra Singh Airee',
        'Specialization': 'All Rounder',
    },
    {
        'profileimg': 'Paul van Meekeren.png',
        'PlayerName': 'Paul Van Meekeren',
        'Specialization': 'Bowler',
    },
    {
        'profileimg': 'Richard Berrington.png',
        'PlayerName': 'Richard Berrington',
        'Specialization': 'Batting Allrounder',
    },
    {
        'profileimg': 'Jeremy Gordon.png',
        'PlayerName': 'Jeremy Gordon',
        'Specialization': 'Bowler',
    },
    {
        'profileimg': 'Harsh Thaker.png',
        'PlayerName': 'Harsh Thaker',
        'Specialization': 'All Rounder',
    },
    {
        'profileimg': 'Rishiv  Joshi.png',
        'PlayerName': 'Rishiv Joshi',
        'Specialization': 'All Rounder',
    },
    {
        'profileimg': 'Yuvraj Samra.png',
        'PlayerName': 'Yuvraj Samra',
        'Specialization': 'Batter',
    },
    {
      'profileimg': 'Ajayveer Singh.png',
      'PlayerName': 'Ajayveer Singh',
      'Specialization': 'Bowler',
    },
    {
        'profileimg': 'MUNIR KAKAR.png',
        'PlayerName': 'Munir Kakar',
        'Specialization': 'Allrounder',
    },
    {
        'profileimg': 'MANDEEP GIRDHAR.png',
        'PlayerName': 'Mandeep Girdhar',
        'Specialization': 'All Rounder',
    },
    {
      'profileimg': 'Nitish kumar.png',
      'PlayerName': 'Nitish Kumar',
      'Specialization': 'Batter',
    },
    {
      'profileimg': 'shubham sharma.png',
      'PlayerName': 'Shubham Sharma',
      'Specialization': '-',
    }
];

    } else if (this.yearnameforimage == '2023') {
      this.teamPlayers = [
        {
          'profileimg': 'Mohammad Rizwan.png',
          'PlayerName': 'Mohammad Rizwan',
          'Specialization': 'Wicketkeeper Batter',
        },
        {
          'profileimg': 'Rassie VAn Der Dussen.png',
          'PlayerName': 'Rassie van der Dussen',
          'Specialization': 'Batter',
        },
        {
          'profileimg': 'Naveen Ul Haq.png',
          'PlayerName': 'Naveen-ul-Haq',
          'Specialization': 'bowler',
        },
        {
          'profileimg': 'Reeza Raphael Hendricks.png',
          'PlayerName': 'Reeza Raphael Hendricks',
          'Specialization': 'Batter',
        },
        {
          'profileimg': 'Corbin Bosch.png',
          'PlayerName': 'Corbin Bosch',
          'Specialization': 'all rounder',
        },
        {
          'profileimg': 'Najibullah Zadran.png',
          'PlayerName': 'Najibullah Zadran',
          'Specialization': 'Batter',
        },
        {
          'profileimg': 'Junaid Siddique.png',
          'PlayerName': 'Junaid Siddique',
          'Specialization': 'bowler',
        },
        {
          'profileimg': 'Vriitya Aravind.png',
          'PlayerName': 'Vriitya Aravind',
          'Specialization': 'Wicketkeeper Batter',
        },
        {
          'profileimg': 'Karthik Meiyappam.png',
          'PlayerName': 'Karthik Meiyappam',
          'Specialization': 'bowler',
        },
        {
          'profileimg': 'Ruben Trumpelmann.png',
          'PlayerName': 'Ruben Trumplemann',
          'Specialization': 'bowler',
        },
        {
          'profileimg': 'Ravinderpal Singh.png',
          'PlayerName': 'Ravinderpal Singh',
          'Specialization': 'Batter',
        },
        {
          'profileimg': 'Harsh Thaker.png',
          'PlayerName': 'Harsh Thaker',
          'Specialization': 'all rounder',
        },
        {
          'profileimg': 'Rayyan Pathan.png',
          'PlayerName': 'Rayyan Pathan',
          'Specialization': 'all rounder',
        },
        {
          'profileimg': 'Nawab Singh.png',
          'PlayerName': 'Nawab Singh',
          'Specialization': 'bowler',
        },
        {
          'profileimg': 'Muhammad Kamal.png',
          'PlayerName': 'Muhammad Kamal',
          'Specialization': 'bowler',
        },
        {
          'profileimg': 'player-default.png',
          'PlayerName': 'Kanwar Tathgur',
          'Specialization': 'Batter',
        }
      ]
    } else {
      this.server.getjsonData('teams/stats' + this.yearname + '/vancouver_players.json').subscribe(data => {
        this.teamPlayers = data['playerstats'];
      });
    }
  }
  getRsultJson() {
    this.server.getjsonData('results/results_' + this.yearname + '.json').subscribe(data => {
      this.allResult = data['matchsummary'];
      this.allResult.forEach(element => {
        if (element.FirstBattingTeamName == 'VANCOUVER KNIGHTS' || element.SecondBattingTeamName == 'VANCOUVER KNIGHTS') {
          this.teamNameData.push(element)
        }
      });
    });
  }
  getStatsJson() {
    this.server.getjsonData('teams/stats' + this.yearname + '/vancouver_players.json').subscribe(data => {
      this.teamPlayersStats = data['playerstats'];
    });
  }


  ngOnInit() {
    this.getInnerHeight();
    this.getSquadJson();
    this.getRsultJson();
    this.getStatsJson();
  }

  SquadData(year) {
    if (year !== '2023') {
      this.yearname = year;
    }
    this.yearnameforimage = year;
    this.teamPlayers = [];
    this.getSquadJson();
  }
  ResultData(year) {
    this.yearname = year;
    this.teamNameData = [];
    this.getRsultJson();
  }
  StatsData(year) {
    this.yearname = year;
    this.teamPlayersStats = [];
    this.getStatsJson();
  }


  ShowPlayer: boolean = true;
  PlayerName: any;
  BowlingType: any;
  BattingType: any;
  Specialization: any;
  profileimg: any;
  Dataforbutton: any;


  Matches: any;
  Innings: any;
  RunsScored: any;
  BallsFaced: any;
  StrikeRate: any;
  BattingAverage: any;
  Bdry4Scored: any;
  Bdry6Scored: any;
  Fifties: any;
  Hundreds: any;
  OversBowled: any;
  TotalRunsConceeded: any;
  WicketsTaken: any;
  BowlingAverage: any;
  Maidens: any;
  BowlingSR: any;
  EconomyRate: any;

  HidePlayer: boolean = false;
  testplyerId: any;
  openTeamPlayer(value) {
    this.getSquadJson();
    for (let data of this.teamPlayers) {
      if (data.PlayerID == value.PlayerID) {
        this.testplyerId = data.PlayerID;
      }
    }
    this.server.topFunction();
    this.ShowPlayer = false;
    this.HidePlayer = true;
    this.Dataforbutton = value;
    this.PlayerName = value.PlayerName
    this.BowlingType = value.BowlingType
    this.BattingType = value.BattingType
    this.Specialization = value.Specialization
    this.profileimg = value.profileimg

    this.OversBowled = value.OversBowled
    this.Matches = value.Matches
    this.RunsScored = value.RunsScored
    // ---------Batting
    this.BattingAverage = value.BattingAverage
    this.StrikeRate = value.StrikeRate
    this.Fifties = value.Fifties
    this.Hundreds = value.Hundreds
    this.Bdry4Scored = value.Bdry4Scored
    this.Bdry6Scored = value.Bdry6Scored
    this.BallsFaced = value.BallsFaced
    this.Innings = value.Innings;
    // ------------Bowlling
    this.TotalRunsConceeded = value.TotalRunsConceeded
    this.WicketsTaken = value.WicketsTaken
    this.BowlingAverage = value.BowlingAverage
    this.EconomyRate = value.EconomyRate
    this.BowlingSR = value.BowlingSR
    this.Maidens = value.Maidens
    this.Innings = value.Innings
  }
  openPlayerDetails(playerDetails) {
    this.matchroW = playerDetails.MatchRow;
    this.urlRefresh = 'https://gt20.in/matchcenter/results?match=' + this.matchroW + '&season=' + this.yearname;
    window.open(this.urlRefresh, "_self");
  }
}
